import styled from 'styled-components'

export const LabelStyled = styled.label`
  font-weight: 600;
  margin-left: 10px;
  font-size: 16px;
`